module.exports = __webpack_public_path__ + "media/4.c0a31891.mp3";